import React from 'react';

export default function ErrorBanner({ message }) {
  if (!message) return null;
  return (
    <div
      className="flex items-center gap-2 rounded-lg px-3 py-2.5"
      style={{ backgroundColor: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)' }}
    >
      <svg className="w-4 h-4 flex-shrink-0" style={{ color: '#f87171' }} fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <p className="text-xs" style={{ color: '#f87171' }}>{message}</p>
    </div>
  );
}
